import { PortreteHero } from "@/components/portrete/PortreteHero";
import { Perdorimet, SiFunksionon, Detaji } from "@/components/portrete/Sections";
import { Contatti } from "@/components/site/Contatti";

export default function Portrete() {
  return (
    <main data-testid="portrete-page">
      <PortreteHero />
      <Perdorimet />
      <SiFunksionon />
      <Detaji />
      <Contatti />
    </main>
  );
}
